<app-header></app-header>
<app-leftsidebar [activePath]="activePath"></app-leftsidebar>

<div class="ccv-main">
  <div class="right-sec">
    <div class="ccv-wrap">

      <div class="ccv-head">
        <div class="ccv-head-text">
          <h1>Content <span class="gold">Vault</span></h1>
          <p>Everything you've made and everything you've bought, in one place.</p>
        </div>
        <div class="ccv-head-actions">
          <a class="btn btn-dark" [routerLink]="userId ? ['/marketplace/vendor-dashboard/bulk-upload'] : ['/login']">
            Bulk upload
          </a>
          <a class="btn btn-theme" [routerLink]="userId ? ['/add-edit-content'] : ['/login']">
            New content
          </a>
        </div>
      </div>

      <div class="ccv-toolbar">
        <div class="ccv-tabs" role="tablist">
          <button role="tab" [attr.aria-selected]="selectedTab === 'created'" (click)="selectedTab = 'created'; filterOpen = false">
            Created <span class="ccv-count">{{ createdContent.length }}</span>
          </button>
          <button role="tab" [attr.aria-selected]="selectedTab === 'purchased'" (click)="selectedTab = 'purchased'; filterOpen = false">
            Purchased <span class="ccv-count">{{ purchasedContent.length }}</span>
          </button>
          <button role="tab" [attr.aria-selected]="selectedTab === 'drafts'" (click)="selectedTab = 'drafts'; filterOpen = false">
            Drafts <span class="ccv-count">{{ draftContent.length }}</span>
          </button>
        </div>
      </div>

      <p class="ccv-help">
        <ng-container [ngSwitch]="selectedTab">
          <ng-container *ngSwitchCase="'created'">Modules you've published. Edit, unpublish, or check them here.</ng-container>
          <ng-container *ngSwitchCase="'purchased'">Modules you've bought from the store — open one to run it.</ng-container>
          <ng-container *ngSwitchDefault>Unfinished modules. Keep writing, then publish when they're ready.</ng-container>
        </ng-container>
      </p>

      <div class="ccv-controls">
        <div class="ccv-search" #filterWrap>
          <svg class="ccv-search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
            <circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" />
          </svg>
          <input type="search" placeholder="Search your vault" [(ngModel)]="search" />
          <button type="button" class="ccv-search-filter"
            [class.is-on]="!!selectedType"
            [attr.aria-expanded]="filterOpen"
            aria-haspopup="listbox"
            aria-controls="ccv-filter-menu"
            [attr.aria-label]="selectedType ? 'Filter by type, ' + selectedType + ' selected' : 'Filter by type'"
            (click)="toggleFilter($event)">
            <svg class="ccv-search-filter-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <rect x="3" y="5" width="18" height="2.2" rx="1.1"/>
              <rect x="3" y="10" width="14" height="2.2" rx="1.1"/>
              <rect x="3" y="15" width="10" height="2.2" rx="1.1"/>
              <rect x="3" y="20" width="6" height="2.2" rx="1.1"/>
            </svg>
          </button>
          <div class="ccv-filter-menu" id="ccv-filter-menu" role="listbox" aria-label="Filter by content type"
            *ngIf="filterOpen">
            <button type="button" role="option"
              [attr.aria-selected]="!selectedType"
              (click)="selectType('')">
              All <span class="ccv-count">{{ tabContent.length }}</span>
            </button>
            <button type="button" role="option" *ngFor="let t of contentTypes"
              [attr.aria-selected]="selectedType === t"
              (click)="selectType(t)">
              {{ t }} <span class="ccv-count">{{ typeCount(t) }}</span>
            </button>
          </div>
        </div>
      </div>

      <div class="ccv-grid">
        <article class="ccv-card" *ngFor="let content of visibleContent">
          <div class="ccv-card-tags">
            <button type="button" class="chip ccv-type-{{ typeSlug(content.type) }}" *ngIf="content.type"
              (click)="selectType(content.type)"
              [attr.aria-pressed]="selectedType === content.type">
              {{ content.type }}
            </button>
            <span class="chip chip-pending" *ngIf="content.status === 'draft' || content.is_draft">Draft</span>
            <span class="chip chip-yours" *ngIf="isMine(content) && content.status !== 'draft' && !content.is_draft">Yours</span>
          </div>

          <h3 class="ccv-name">
            <a [routerLink]="['/add-edit-content']" [queryParams]="contentQueryParams(content)">
              {{ content.content_title || 'Untitled module' }}
            </a>
          </h3>
          <p class="ccv-meta">
            {{ content.gamesystem || 'System TBD' }}
            <ng-container *ngIf="content.map_name"> · {{ content.map_name }}</ng-container>
          </p>

          <div class="ccv-stats">
            <div class="ccv-stat"><span class="v">{{ content.playtime || '—' }}</span><span class="k">Playtime · hrs</span></div>
            <div class="ccv-stat"><span class="v">{{ content.partyaverage || '—' }}</span><span class="k">Party avg</span></div>
            <div class="ccv-stat"><span class="v">{{ content.recommend_player || '—' }}</span><span class="k">Players</span></div>
          </div>

          <div class="ccv-card-actions">
            <a class="btn btn-green" [routerLink]="['/add-edit-content']" [queryParams]="contentQueryParams(content)">
              {{ isMine(content) ? 'Edit' : 'View' }}
            </a>
            <button type="button" class="btn btn-outline ccv-del" *ngxPermissionsOnly="['ADMIN']"
              (click)="deleteContentRecord(content)" aria-label="Delete">
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </article>

        <a class="ccv-add" *ngIf="selectedTab === 'created' && !isFiltered"
          [routerLink]="userId ? ['/add-edit-content'] : ['/login']">
          <span class="ccv-add-plus">+</span>
          <span class="ccv-add-label">Create a module</span>
          <span class="ccv-add-sub">Establishment, adventure or campaign — start from a blank sheet.</span>
        </a>

        <p class="ccv-empty" *ngIf="visibleContent.length === 0 && isFiltered">
          No modules match these filters.
          <button type="button" class="ccv-clear" (click)="clearFilters()">Clear filters</button>
        </p>
        <p class="ccv-empty" *ngIf="visibleContent.length === 0 && !isFiltered && selectedTab === 'purchased'">
          You haven't purchased any modules yet.
        </p>
        <p class="ccv-empty" *ngIf="visibleContent.length === 0 && !isFiltered && selectedTab === 'drafts'">
          No drafts yet — start a module and save it before publishing.
        </p>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
